export const appendToArrayOrDeleteIfExists = (array: string[], value: string) => {
  if (!array.includes(value)) {
    array.push(value);
  } else {
    array.splice(array.indexOf(value), 1);
  }
};
